"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PermissionTooltip = require("./PermissionTooltip.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PermissionTooltip = function PermissionTooltip(_ref) {
  var displayTooltip = _ref.displayTooltip,
    targetElementId = _ref.targetElementId,
    _ref$requiredRole = _ref.requiredRole,
    requiredRole = _ref$requiredRole === void 0 ? 'Show caller' : _ref$requiredRole;
  if (!displayTooltip) return null;
  return _react["default"].createElement(_PermissionTooltip.TooltipStyled, {
    placement: 'bottom',
    target: targetElementId,
    style: _PermissionTooltip.TooltipInlineStyle
  }, "".concat(requiredRole, " permission is required"));
};
PermissionTooltip.propTypes = {
  requiredRole: _propTypes["default"].string,
  displayTooltip: _propTypes["default"].bool.isRequired,
  targetElementId: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = (0, _react.memo)(PermissionTooltip);